export class AgencyInformation {
    agency: string;
    agentName: string;
    agentMobile: string;
    agentHrsOfOperation: string;
    agentEmail: string;
}
